export enum LoadBalancingStrategyEnum {
  None = 'none',
  BalancingBeforeSession = 'balancing_before_session',
  BalancingDuringSession = 'balancing_during_session',
}
